import custom from './svgs/custom.svg';

export const widgetMap = [
  {
    componentName: 'widget',
    componentLabel: 'Custom Widget',
    image: custom
  }
];
